import React, { useState } from "react";

const PurchaseRequestSystem = () => {
  const [activeTab, setActiveTab] = useState("dados-gerais");
  const [showAddItemModal, setShowAddItemModal] = useState(false);

  const [formData, setFormData] = useState({
    localEstoque: "1001",
    organizacao: "ORGANIZAÇÃO DOS RELIGIOSOS DE SANTA CRUZ",
    centroCusto: "4.01.01.01.006",
    distrital: "Com Distrital N S Dores",
    tipoSolicitacao: "Produtos",
    dataEntrega: "2025-03-27",
    observacao: "",
    convenio: "",
    pagamentoConvenio: "",
  });

  const [items, setItems] = useState([
    {
      id: 1,
      name: "ABACATE KG",
      description: "Abacate fresco, qualidade premium",
      quantity: 20.0,
      unit: "KG",
      price: 15.0,
      category: "Alimentação",
    },
    {
      id: 2,
      name: "ARROZ INTEGRAL",
      description: "Arroz integral tipo 1, embalagem 5kg",
      quantity: 10.0,
      unit: "CX",
      price: 45.0,
      category: "Alimentação",
    },
    {
      id: 3,
      name: "PAPEL A4",
      description: "Papel sulfite A4 75g, resma 500 folhas",
      quantity: 50.0,
      unit: "UN",
      price: 25.0,
      category: "Material de Escritório",
    },
  ]);

  const [newItem, setNewItem] = useState({
    name: "",
    description: "",
    quantity: "",
    unit: "KG",
    price: "",
    category: "Alimentação",
  });

  const [filters, setFilters] = useState({
    search: "",
    category: "todas",
  });

  // Cálculos derivados
  const totalItems = items.length;
  const totalValue = items.reduce(
    (sum, item) => sum + item.quantity * item.price,
    0
  );
  const newItemTotal =
    (parseFloat(newItem.quantity) || 0) * (parseFloat(newItem.price) || 0);

  // Filtrar itens
  const filteredItems = items.filter((item) => {
    const matchesSearch =
      item.name.toLowerCase().includes(filters.search.toLowerCase()) ||
      item.description.toLowerCase().includes(filters.search.toLowerCase());
    const matchesCategory =
      filters.category === "todas" || item.category === filters.category;
    return matchesSearch && matchesCategory;
  });

  const categorias = [...new Set(items.map((item) => item.category))];

  // Handlers
  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleNewItemChange = (field, value) => {
    setNewItem((prev) => ({ ...prev, [field]: value }));
  };

  const addItem = () => {
    if (newItem.name && newItem.quantity && newItem.price) {
      const item = {
        ...newItem,
        id: items.length + 1,
        quantity: parseFloat(newItem.quantity),
        price: parseFloat(newItem.price),
      };
      setItems([...items, item]);
      setNewItem({
        name: "",
        description: "",
        quantity: "",
        unit: "KG",
        price: "",
        category: "Alimentação",
      });
      setShowAddItemModal(false);
    }
  };

  const removeItem = (id) => {
    if (window.confirm("Tem certeza que deseja remover este item?")) {
      setItems(items.filter((item) => item.id !== id));
    }
  };

  const formatCurrency = (value) => {
    return `R$ ${value.toFixed(2).replace(".", ",")}`;
  };

  const getBadgeColor = (category) => {
    const colors = {
      Alimentação: "bg-primary",
      "Material de Escritório": "bg-info",
      Limpeza: "bg-success",
      Manutenção: "bg-warning",
    };
    return colors[category] || "bg-secondary";
  };

  // Componentes
  const StatCard = ({
    title,
    value,
    subtitle,
    colorClass = "text-primary",
  }) => (
    <div className="card mb-3" style={{ border: "1px solid #dee2e6" }}>
      <div className="card-body p-3">
        <div className="text-muted small">{title}</div>
        <div className={`fs-4 fw-bold ${colorClass}`}>{value}</div>
        <div className="text-muted small">{subtitle}</div>
      </div>
    </div>
  );

  const TabButton = ({ id, label, icon, active, onClick }) => (
    <button
      className={`nav-link ${active ? "active" : ""}`}
      onClick={() => onClick(id)}
      style={{
        border: "none",
        backgroundColor: active ? "#0d6efd" : "transparent",
        color: active ? "white" : "#6c757d",
        borderRadius: "8px",
        marginRight: "0.5rem",
      }}
    >
      <i className={`bi ${icon} me-2`}></i>
      {label}
    </button>
  );

  return (
    <>
      {/* Bootstrap CSS */}
      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/css/bootstrap.min.css"
        rel="stylesheet"
      />
      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap-icons/1.10.0/font/bootstrap-icons.min.css"
        rel="stylesheet"
      />

      <div style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
        {/* Header */}
        <header
          className="bg-white border-bottom"
          style={{
            position: "sticky",
            top: 0,
            zIndex: 1030,
            boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
          }}
        >
          <div className="container-fluid px-4 py-3">
            <div className="row align-items-center">
              <div className="col">
                <h1 className="h4 mb-1 fw-bold">
                  Solicitação de Compras #SC-2025-001
                </h1>
                <small className="text-muted">
                  Criada em 08/07/2025 • Status: Rascunho
                </small>
              </div>
              <div className="col-auto">
                <div className="btn-group">
                  <button className="btn btn-outline-secondary btn-sm">
                    <i className="bi bi-download me-1"></i>Exportar
                  </button>
                  <button className="btn btn-outline-secondary btn-sm">
                    <i className="bi bi-eye me-1"></i>Visualizar
                  </button>
                  <button className="btn btn-primary btn-sm">
                    <i className="bi bi-save me-1"></i>Salvar Rascunho
                  </button>
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* Main Container */}
        <div className="d-flex" style={{ height: "calc(100vh - 80px)" }}>
          {/* Sidebar */}
          <div
            className="bg-white border-end"
            style={{
              width: "320px",
              overflowY: "auto",
              borderRight: "1px solid #dee2e6",
            }}
          >
            <div className="p-4 border-bottom">
              <h5 className="fw-semibold mb-3">Resumo da Solicitação</h5>

              <StatCard
                title="Total de Itens"
                value={totalItems}
                subtitle="produtos adicionados"
                colorClass="text-success"
              />

              <StatCard
                title="Valor Total"
                value={formatCurrency(totalValue)}
                subtitle="valor estimado"
                colorClass="text-primary"
              />

              <StatCard
                title="Data de Entrega"
                value="27/03/2025"
                subtitle="prazo mínimo 10 dias"
                colorClass="text-warning"
              />
            </div>

            <div className="p-4 border-bottom">
              <h6 className="fw-semibold mb-3">Informações Básicas</h6>
              <div className="mb-3">
                <div className="text-muted small">Local:</div>
                <div className="fw-medium">{formData.localEstoque}</div>
              </div>
              <div className="mb-3">
                <div className="text-muted small">Centro de Custo:</div>
                <div className="fw-medium">{formData.centroCusto}</div>
              </div>
              <div className="mb-3">
                <div className="text-muted small">Tipo:</div>
                <div className="fw-medium">{formData.tipoSolicitacao}</div>
              </div>
            </div>

            <div className="p-4">
              <button
                className="btn btn-success w-100 mb-2"
                onClick={() => setShowAddItemModal(true)}
              >
                <i className="bi bi-plus-lg me-2"></i>Adicionar Item
              </button>
              <button className="btn btn-primary w-100">
                Finalizar Solicitação
              </button>
            </div>
          </div>

          {/* Main Content */}
          <div className="flex-fill" style={{ overflowY: "auto" }}>
            {/* Tabs */}
            <div className="bg-white border-bottom px-4 py-3">
              <ul className="nav nav-tabs border-0">
                <li className="nav-item">
                  <TabButton
                    id="dados-gerais"
                    label="Dados Gerais"
                    icon="bi-file-text"
                    active={activeTab === "dados-gerais"}
                    onClick={setActiveTab}
                  />
                </li>
                <li className="nav-item">
                  <TabButton
                    id="itens"
                    label="Lista de Itens"
                    icon="bi-box"
                    active={activeTab === "itens"}
                    onClick={setActiveTab}
                  />
                </li>
                <li className="nav-item">
                  <TabButton
                    id="financeiro"
                    label="Financeiro"
                    icon="bi-credit-card"
                    active={activeTab === "financeiro"}
                    onClick={setActiveTab}
                  />
                </li>
              </ul>
            </div>

            {/* Tab Content */}
            <div
              className="p-4"
              style={{ height: "calc(100vh - 160px)", overflowY: "auto" }}
            >
              {activeTab === "dados-gerais" && (
                <div className="row g-4">
                  <div className="col-lg-6">
                    <div className="card">
                      <div className="card-body">
                        <h5 className="card-title">
                          <i className="bi bi-geo-alt text-primary me-2"></i>
                          Localização
                        </h5>
                        <div className="mb-3">
                          <label className="form-label">
                            Local de Estoque *
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.localEstoque}
                            onChange={(e) =>
                              handleInputChange("localEstoque", e.target.value)
                            }
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Organização *</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.organizacao}
                            onChange={(e) =>
                              handleInputChange("organizacao", e.target.value)
                            }
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">
                            Centro de Custo *
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.centroCusto}
                            onChange={(e) =>
                              handleInputChange("centroCusto", e.target.value)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="card">
                      <div className="card-body">
                        <h5 className="card-title">
                          <i className="bi bi-box text-primary me-2"></i>
                          Detalhes da Solicitação
                        </h5>
                        <div className="mb-3">
                          <label className="form-label">
                            Tipo de Solicitação *
                          </label>
                          <select
                            className="form-select"
                            value={formData.tipoSolicitacao}
                            onChange={(e) =>
                              handleInputChange(
                                "tipoSolicitacao",
                                e.target.value
                              )
                            }
                          >
                            <option value="Produtos">Produtos</option>
                            <option value="Serviços">Serviços</option>
                            <option value="Materiais">Materiais</option>
                          </select>
                        </div>
                        <div className="mb-3">
                          <label className="form-label">
                            Data de Entrega *
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            value={formData.dataEntrega}
                            onChange={(e) =>
                              handleInputChange("dataEntrega", e.target.value)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <h5 className="card-title">Observações</h5>
                        <textarea
                          className="form-control"
                          rows="4"
                          placeholder="Justifique com detalhamento de informações sobre a solicitação..."
                          value={formData.observacao}
                          onChange={(e) =>
                            handleInputChange("observacao", e.target.value)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "itens" && (
                <div>
                  {/* Filtros */}
                  <div className="card mb-4">
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-auto">
                          <div style={{ position: "relative" }}>
                            <i
                              className="bi bi-search"
                              style={{
                                position: "absolute",
                                left: "12px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                color: "#6c757d",
                              }}
                            ></i>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Buscar itens..."
                              style={{ paddingLeft: "40px" }}
                              value={filters.search}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  search: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                        <div className="col-auto">
                          <select
                            className="form-select"
                            value={filters.category}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                category: e.target.value,
                              })
                            }
                          >
                            <option value="todas">Todas as categorias</option>
                            {categorias.map((cat) => (
                              <option key={cat} value={cat}>
                                {cat}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-auto">
                          <small className="text-muted">
                            <i className="bi bi-funnel me-1"></i>
                            {filteredItems.length} de {totalItems} itens
                          </small>
                        </div>
                        <div className="col-auto ms-auto">
                          <button
                            className="btn btn-success"
                            onClick={() => setShowAddItemModal(true)}
                          >
                            <i className="bi bi-plus-lg me-2"></i>Novo Item
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Tabela de Itens */}
                  <div className="card">
                    <div className="table-responsive">
                      <table className="table table-hover mb-0">
                        <thead className="table-light">
                          <tr>
                            <th>Item</th>
                            <th>Categoria</th>
                            <th>Quantidade</th>
                            <th>Valor Unit.</th>
                            <th>Valor Total</th>
                            <th width="100">Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredItems.map((item) => {
                            const total = item.quantity * item.price;
                            return (
                              <tr key={item.id}>
                                <td>
                                  <div>
                                    <div className="fw-medium">{item.name}</div>
                                    <small className="text-muted">
                                      {item.description}
                                    </small>
                                  </div>
                                </td>
                                <td>
                                  <span
                                    className={`badge ${getBadgeColor(
                                      item.category
                                    )}`}
                                    style={{ fontSize: "0.75rem" }}
                                  >
                                    {item.category}
                                  </span>
                                </td>
                                <td>
                                  {item.quantity.toFixed(4)} {item.unit}
                                </td>
                                <td>{formatCurrency(item.price)}</td>
                                <td className="fw-medium">
                                  {formatCurrency(total)}
                                </td>
                                <td>
                                  <button
                                    className="btn btn-outline-primary btn-sm me-1"
                                    style={{
                                      padding: "0.375rem",
                                      width: "32px",
                                      height: "32px",
                                    }}
                                    title="Editar"
                                  >
                                    <i className="bi bi-pencil"></i>
                                  </button>
                                  <button
                                    className="btn btn-outline-danger btn-sm"
                                    style={{
                                      padding: "0.375rem",
                                      width: "32px",
                                      height: "32px",
                                    }}
                                    title="Excluir"
                                    onClick={() => removeItem(item.id)}
                                  >
                                    <i className="bi bi-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "financeiro" && (
                <div className="row g-4">
                  <div className="col-lg-6">
                    <div className="card">
                      <div className="card-body">
                        <h5 className="card-title">
                          <i className="bi bi-credit-card text-primary me-2"></i>
                          Convênio e Pagamento
                        </h5>
                        <div className="mb-3">
                          <label className="form-label">Convênio</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Selecionar convênio..."
                            value={formData.convenio}
                            onChange={(e) =>
                              handleInputChange("convenio", e.target.value)
                            }
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">
                            Forma de Pagamento
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Forma de pagamento..."
                            value={formData.pagamentoConvenio}
                            onChange={(e) =>
                              handleInputChange(
                                "pagamentoConvenio",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="card">
                      <div className="card-body">
                        <h5 className="card-title">
                          <i className="bi bi-calculator text-primary me-2"></i>
                          Resumo Financeiro
                        </h5>
                        <div className="d-flex justify-content-between mb-2">
                          <span className="text-muted">Subtotal:</span>
                          <span className="fw-medium">
                            {formatCurrency(totalValue)}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between mb-2">
                          <span className="text-muted">Impostos:</span>
                          <span className="fw-medium">R$ 0,00</span>
                        </div>
                        <div className="d-flex justify-content-between mb-3">
                          <span className="text-muted">Desconto:</span>
                          <span className="fw-medium">R$ 0,00</span>
                        </div>
                        <hr />
                        <div className="d-flex justify-content-between fs-5 fw-bold">
                          <span>Total Geral:</span>
                          <span className="text-primary">
                            {formatCurrency(totalValue)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Modal Adicionar Item */}
        {showAddItemModal && (
          <div
            className="modal fade show"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
            onClick={(e) =>
              e.target === e.currentTarget && setShowAddItemModal(false)
            }
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div
                  className="modal-header"
                  style={{ backgroundColor: "#f8f9fa" }}
                >
                  <h5 className="modal-title">Adicionar Novo Item</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowAddItemModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label">Nome do Item *</label>
                      <input
                        type="text"
                        className="form-control"
                        value={newItem.name}
                        onChange={(e) =>
                          handleNewItemChange("name", e.target.value)
                        }
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Categoria</label>
                      <select
                        className="form-select"
                        value={newItem.category}
                        onChange={(e) =>
                          handleNewItemChange("category", e.target.value)
                        }
                      >
                        <option value="Alimentação">Alimentação</option>
                        <option value="Material de Escritório">
                          Material de Escritório
                        </option>
                        <option value="Limpeza">Limpeza</option>
                        <option value="Manutenção">Manutenção</option>
                      </select>
                    </div>
                    <div className="col-12">
                      <label className="form-label">Descrição</label>
                      <input
                        type="text"
                        className="form-control"
                        value={newItem.description}
                        onChange={(e) =>
                          handleNewItemChange("description", e.target.value)
                        }
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Quantidade *</label>
                      <input
                        type="number"
                        step="0.0001"
                        className="form-control"
                        value={newItem.quantity}
                        onChange={(e) =>
                          handleNewItemChange("quantity", e.target.value)
                        }
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Unidade de Medida</label>
                      <select
                        className="form-select"
                        value={newItem.unit}
                        onChange={(e) =>
                          handleNewItemChange("unit", e.target.value)
                        }
                      >
                        <option value="KG">Quilograma (KG)</option>
                        <option value="UN">Unidade (UN)</option>
                        <option value="LT">Litro (LT)</option>
                        <option value="MT">Metro (MT)</option>
                        <option value="CX">Caixa (CX)</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Valor Unitário *</label>
                      <input
                        type="number"
                        step="0.01"
                        className="form-control"
                        value={newItem.price}
                        onChange={(e) =>
                          handleNewItemChange("price", e.target.value)
                        }
                      />
                    </div>
                    <div className="col-12">
                      <div className="alert alert-info">
                        <strong>
                          Valor Total: {formatCurrency(newItemTotal)}
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowAddItemModal(false)}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={addItem}
                  >
                    Adicionar Item
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default PurchaseRequestSystem;
